import {
  $getUserId,
  $getAuthToken,
  $getUserData,
  $postLogin,
  $refreshToken,
  $sendResetPasswordMail,
  $postRegistration,
  $patchRegistration,
  $verifyEmailRequest,
  $verifyPhoneRequest,
  $verifyEmailCode,
  $verifyPhoneCode,
  $authorizeFbLogin,
  $changePassword,
  $getUserVehicles,
  $getVehicleTypes,
  $postJobsForm,
  $postCustomerService
} from "@/utils/endpoints";
import { redirectToLogin, constants } from "@/utils/generic";

//TODO REFACTOR FROM store/bookingFunnel.js
//put here every login associated state, getters, mutations, actions

export const state = () => ({
  userId: null,
  token: null,
  authTokenState: null,
  loginUsername: "",
  loginPassword: "",
  loginState: null,
  userData: null,
  phoneNumber: "",
  isVerifyingMail: false,
  isVerifyingPhone: false,
  name: "",
  lastName: "",
  email: "",
  password: "",
  passwordConfirmation: "",
  isAgreementAccepted: false,
  isFormValid: false,
  fiscalCode: "",
  cap: "",
  taxDetailsAddress: "",
  taxDetailsCity: "",
  selectedProvince: null,
  selectedNation: null,
  shouldShowRegistrationErrors: false,
  registrationState: null,
  businessName: null,
  vatNumber: null,
  pec: null,
  sdiCode: null,
  resetPasswordMailSent: false,
  verificationCode: "",
  isVerificationCodeValid: false,
  isValidationCodeBtnDisabled: false,
  mailCodeVerificationState: null,
  phoneCodeVerificationState: null,
  isEditingMailToBeVerified: false,
  isEditingPhoneToBeVerified: false,
  registrationPatchState: null,
  isEditingUserDetails: false,
  isSigninIn: true,
  isSigninUp: false,
  favoriteCity: null,
  gender: null,
  birthday: null,
  changePasswordState: {},
  areTaxDetailsChanged: false,
  selectedTaxDetailsTab: ""
});

const getters = {
  userId: (state) => state.userId,
  token: (state) => state.token,
  isLogged: (state) => !!state.token,
  authTokenState: (state) => state.authTokenState,
  loginUsername: (state) => state.loginUsername,
  loginPassword: (state) => state.loginPassword,
  loginState: (state) => state.loginState,
  userData: (state) => state.userData,
  phoneNumber: (state) => state.phoneNumber,
  isVerifyingMail: (state) => state.isVerifyingMail,
  isVerifyingPhone: (state) => state.isVerifyingPhone,
  name: (state) => state.name,
  lastName: (state) => state.lastName,
  email: (state) => state.email,
  password: (state) => state.password,
  passwordConfirmation: (state) => state.passwordConfirmation,
  isAgreementAccepted: (state) => state.isAgreementAccepted,
  isFormValid: (state) => state.isFormValid,
  fiscalCode: (state) => state.fiscalCode,
  cap: (state) => state.cap,
  taxDetailsAddress: (state) => state.taxDetailsAddress,
  taxDetailsCity: (state) => state.taxDetailsCity,
  selectedProvince: (state) => state.selectedProvince,
  selectedNation: (state) => state.selectedNation,
  shouldShowRegistrationErrors: (state) => state.shouldShowRegistrationErrors,
  registrationState: (state) => state.registrationState,
  businessName: (state) => state.businessName,
  vatNumber: (state) => state.vatNumber,
  pec: (state) => state.pec,
  sdiCode: (state) => state.sdiCode,
  resetPasswordMailSent: (state) => state.resetPasswordMailSent,
  verificationCode: (state) => state.verificationCode,
  isVerificationCodeValid: (state) => state.isVerificationCodeValid,
  isValidationCodeBtnDisabled: (state) => state.isValidationCodeBtnDisabled,
  mailCodeVerificationState: (state) => state.mailCodeVerificationState,
  phoneCodeVerificationState: (state) => state.phoneCodeVerificationState,
  lastMailVerificationCodeRequested: (state) =>
    state.lastMailVerificationCodeRequested,
  lastPhoneVerificationCodeRequested: (state) =>
    state.lastPhoneVerificationCodeRequested,
  isSigninIn: (state) => state.isSigninIn,
  isSigninUp: (state) => state.isSigninUp,
  isEditingMailToBeVerified: (state) => state.isEditingMailToBeVerified,
  isEditingPhoneToBeVerified: (state) => state.isEditingPhoneToBeVerified,
  registrationPatchState: (state) => state.registrationPatchState,
  isEditingUserDetails: (state) => state.isEditingUserDetails,
  favoriteCity: (state) => state.favoriteCity,
  gender: (state) => state.gender,
  birthday: (state) => state.birthday,
  changePasswordState: (state) => state.changePasswordState,
  areTaxDetailsChanged: (state) => state.areTaxDetailsChanged,
  selectedTaxDetailsTab: (state) => state.selectedTaxDetailsTab,
};

const mutations = {
  setUserId: (state, newValue) => (state.userId = newValue),
  getAuthToken(state, value) {
    state.authTokenState = value;
  },
  setToken(state, value) {
    state.token = value;
    state.loginState.token = value;
  },
  setRefreshToken(state, value) {
    state.loginState.refreshToken = value;
  },
  logout(state) {
    state.authTokenState = null;
    state.token = null;

    // clear storages
    const cookieAccepted = localStorage.getItem(constants.COOKIE_ACCEPTED_LK) != null;
    localStorage.clear();
    if(cookieAccepted) localStorage.setItem(constants.COOKIE_ACCEPTED_LK, true);
    sessionStorage.clear();
    // clear cookies
    const cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const key = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie =
        key + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
    }
    redirectToLogin();

  },
  setName(state, value) {
    state.name = value;
  },
  setLastName(state, value) {
    state.lastName = value;
  },
  setPhoneNumber(state, value) {
    state.phoneNumber = value;
  },
  setEmail(state, value) {
    state.email = value;
  },
  setPassword(state, value) {
    state.password = value;
  },
  setPasswordConfirmation(state, value) {
    state.passwordConfirmation = value;
  },
  setAgreementAcceptance(state, value) {
    state.isAgreementAccepted = value;
  },
  setFormValidityState(state, value) {
    state.isFormValid = value;
  },
  selectTaxDetailsTab(state, value) {
    state.areTaxDetailsChanged = true;
    state.selectedTaxDetailsTab = value;
  },
  setFiscalCode(state, value) {
    state.fiscalCode = value?.toUpperCase();
    state.areTaxDetailsChanged = true;
  },
  setCap(state, value) {
    state.cap = value;
    state.areTaxDetailsChanged = true;
  },
  setTaxDetailsAddress(state, value) {
    state.taxDetailsAddress = value;
    state.areTaxDetailsChanged = true;
  },
  setTaxDetailsCity(state, value) {
    state.taxDetailsCity = value;
    state.areTaxDetailsChanged = true;
  },
  selectProvince(state, value) {
    state.selectedProvince = value;
    state.areTaxDetailsChanged = true;
  },
  selectNation(state, value) {
    state.selectedNation = value;
    state.areTaxDetailsChanged = true;
  },
  setBusinessName(state, value) {
    state.businessName = value;
    state.areTaxDetailsChanged = true;
  },
  setVatNumber(state, value) {
    state.vatNumber = value;
    state.areTaxDetailsChanged = true;
  },
  setPec(state, value) {
    state.pec = value;
    state.areTaxDetailsChanged = true;
  },
  setSdiCode(state, value) {
    state.sdiCode = value;
    state.areTaxDetailsChanged = true;
  },
  setShouldShowRegistrationErrors(state, value) {
    state.shouldShowRegistrationErrors = value;
  },
  postRegistration(state, value) {
    state.registrationState = value;
  },
  patchRegistration(state, value) {
    state.registrationPatchState = value;
  },
  deleteRegistrationSensibleInfo(state) {
    state.name = "";
    state.lastName = "";
    state.email = "";
    state.password = "";
    state.passwordConfirmation = "";
    state.fiscalCode = "";
    state.cap = "";
    state.taxDetailsAddress = "";
    state.taxDetailsCity = "";
    state.selectedProvince = null;
    state.selectedNation = null;
    state.businessName = null;
    state.vatNumber = null;
    state.pec = null;
    state.sdiCode = null;
    state.name = "";
    state.lastName = "";
    state.phoneNumber = "";
  },
  setLoginUsername(state, value) {
    state.loginUsername = value;
  },
  setLoginPassword(state, value) {
    state.loginPassword = value;
  },
  postLogin(state, value) {
    state.loginState = value;
    localStorage.setItem(constants.USER_ID_LK, btoa(value.userId));
  },
  deleteLoginSensibleInfo(state) {
    state.loginUsername = "";
    state.loginPassword = "";
  },
  setVerificationCode(state, value) {
    state.verificationCode = value;
  },
  setIsVerificationCodeValid(state, value) {
    state.isVerificationCodeValid = value;
  },
  lastMailVerificationCodeRequested(state, value) {
    state.lastMailVerificationCodeRequested = value;
  },
  lastPhoneVerificationCodeRequested(state, value) {
    state.lastPhoneVerificationCodeRequested = value;
  },
  getUserData(state, value) {
    state.userData = value;
  },
  setIsVerifyingMail(state, value) {
    state.isVerifyingMail = value;
  },
  setIsVerifyingPhone(state, value) {
    state.isVerifyingPhone = value;
  },
  verifyEmailCode(state, value) {
    state.mailCodeVerificationState = value;
    state.userData = value;
  },
  verifyPhoneCode(state, value) {
    state.phoneCodeVerificationState = value;
    state.userData = value;
  },
  setResetPasswordMailSent(state, value) {
    state.resetPasswordMailSent = value;
  },
  setTaxDetails(state, value) {
    state.fiscalCode = value.cod_fisc_pers || value.cod_fisc;
    state.cap = value.domicile_cap || value.piva_cap;
    state.taxDetailsAddress = value.domicile_address || value.piva_address;
    state.taxDetailsCity = value.domicile_city || value.piva_city;
    state.businessName = value.rag_soc;
    state.vatNumber = value.vat_number;
    state.sdiCode = value.addressee_code;
    state.pec = value.pec;
  },
  isSigninIn: (state, newValue) => (state.isSigninIn = newValue),
  isSigninUp: (state, newValue) => (state.isSigninUp = newValue),
  setSigninUpState(state, value) {
    state.isSigninIn = false;
    state.isSigninUp = value;
  },
  setSigninInState(state, value) {
    state.isSigninUp = false;
    state.isSigninIn = value;
  },
  setIsEditingMailToBeVerified(state, value) {
    state.isEditingMailToBeVerified = value;
  },
  setIsEditingPhoneToBeVerified(state, value) {
    state.isEditingPhoneToBeVerified = value;
  },
  setIsEditingUserDetails(state, value) {
    state.isEditingUserDetails = value;
  },
  setFavoriteCity(state, value) {
    state.favoriteCity = value;
  },
  setGender(state, value) {
    state.gender = value;
  },
  setBirthday(state, value) {
    state.birthday = value;
  },
  changePasswordState(state, value) {
    state.changePasswordState = value;
  },
  setAreTaxDetailsChanged(state, value) {
    state.areTaxDetailsChanged = value;
  },
};
const actions = {
  getUserId: async ({ commit }, token) => {
    const res = await $getUserId(token);
    commit("setUserId", res.userId);
  },
  getAuthToken: async ({ commit }, payload) => {
    const res = await $getAuthToken(payload);
    commit("getAuthToken", res);
    if (res.id) {
      commit("setToken", res.id);
    }
  },
  getUserData: async ({ commit }, { id, token, gtag }) => {
    const promises = [
      $getUserData(id, token),
      $getUserVehicles(id, token),
      $getVehicleTypes(token),
    ];
    const [userDataRes, userVehiclesRes, vehicleTypes] = await Promise.all(
      promises
    );
    commit("getUserData", userDataRes);
    if (userVehiclesRes && vehicleTypes) {
      const vehicles = userVehiclesRes.reduce((acc, curr, index) => {
        const vehicleNumber = ++index;
        const vehicle = {};
        vehicle[`vehicle_${vehicleNumber}_type`] =
          curr.vehicle_type_id === "1" ? "Scooter" : "Auto";
        vehicle[`vehicle_${vehicleNumber}_brand`] = curr.brand;
        vehicle[`vehicle_${vehicleNumber}_model`] = curr.model;
        // console.log(vehicleTypes.find(
        //   (vehicleType) => vehicleType.id === curr.vehicle_type_id
        // ))

        if (curr.vehicle_type_id) {
          vehicle[`vehicle_${vehicleNumber}_segment`] = vehicleTypes.find(
            (vehicleType) => vehicleType.id === curr.vehicle_type_id
          ).short_type;
        }

        vehicle[`vehicle_${vehicleNumber}_plate_letter`] = curr.number_plate ? curr.number_plate.substring(0,2) : '';
        acc.push(vehicle);
        return acc;
      }, []);
      localStorage.setItem(constants.IS_LOGGED_USER_LK, true);
      if (gtag) {
        let userProperties = {
          user_id: id,
          city: userDataRes.city_id,
          domicile_city: userDataRes.domicile_city || userDataRes.piva_city,
          gender: userDataRes.gender,
          date_of_birth: userDataRes.date_of_born,
          type_of_user:
            userDataRes.invoice_type_default === "private"
              ? "individual"
              : "company",
        };
        if(vehicles && vehicles.length > 0) {
          const vehiclesNumb = vehicles.length > 3 ? 3 : vehicles.length;
          for(let i = 0; i < vehiclesNumb; i++) {
            const j = i + 1;
            userProperties[`vehicle_${j}_type`] = vehicles[i][`vehicle_${j}_type`];
            userProperties[`vehicle_${j}_brand`] = vehicles[i][`vehicle_${j}_brand`];
            userProperties[`vehicle_${j}_model`] = vehicles[i][`vehicle_${j}_model`];
            userProperties[`vehicle_${j}_segment`] = vehicles[i][`vehicle_${j}_segment`];
            userProperties[`vehicle_${j}_plate_letter`] = vehicles[i][`vehicle_${j}_plate_letter`];
          }
        }
        gtag.set("user_properties", userProperties);
      }
    }
  },
  impersonate: async ({ commit }, user) => {
    commit("postLogin", user);
  },
  postLogin: async ({ commit }, payload) => {
    const res = await $postLogin(payload);
    commit("postLogin", res);
  },
  postJobsForm: async ({ commit }, payload) => { // eslint-disable-line
    return await $postJobsForm(payload);
  },
  postCustomerService: async ({ commit }, payload) => { // eslint-disable-line
    return await $postCustomerService(payload);
  },
  sendResetPasswordMail: async ({ commit }, email) => {
    await $sendResetPasswordMail(email);
    commit("setResetPasswordMailSent", true);
  },
  requestMailVerificationCode: async ({ commit }, token) => {
    await $verifyEmailRequest(token);
    commit("lastMailVerificationCodeRequested", new Date().getTime());
  },
  requestPhoneVerificationCode: async ({ commit }, token) => {
    await $verifyPhoneRequest(token);
    commit("lastPhoneVerificationCodeRequested", new Date().getTime());
  },
  verifyEmailCode: async ({ commit }, { code, token }) => {
    const res = await $verifyEmailCode({ code }, token);
    commit("verifyEmailCode", res.client);
  },
  verifyPhoneCode: async ({ commit }, { code, token }) => {
    const res = await $verifyPhoneCode({ code }, token);
    commit("verifyPhoneCode", res.client);
  },
  postRegistration: async ({ commit }, payload) => {
    const res = await $postRegistration(payload);
    commit("postRegistration", res);
  },
  patchRegistration: async ({ commit }, { payload, userId, token }) => {
    const res = await $patchRegistration(payload, userId, token);
    commit("patchRegistration", res);
  },
  redirectUnauthorizedUser: async ({ commit, dispatch }) => {
    await dispatch("logout");
    commit("setSigninUpState", false);
    commit("setSigninInState", true);
    redirectToLogin();
  },
  initFacebook: async () => {
    if (!window.FB) {
      return new Promise((resolve) => {
        // wait for facebook sdk to initialize before starting the vue app
        window.fbAsyncInit = function () {
          window.FB.init({
            appId: "1258387470913094",
            xfbml: true,
            version: "v9.0",
          });

          // auto authenticate with the api if already logged in with facebook
          // window.FB.getLoginStatus(({ authResponse }) => {
          //   if (authResponse) {
          //     accountService
          //       .apiAuthenticate(authResponse.accessToken)
          //       .then(resolve);
          //   } else {
          //     resolve();
          //   }
          // });
          resolve();
        };

        // load facebook sdk script
        (function (d, s, id) {
          var js,
            fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) {
            return;
          }
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk.js";
          fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
      });
    }
  },
  facebookLogin: async ({ dispatch }, cb) => {
    window.FB.login(async (fbResponse) => {
      if (fbResponse.authResponse) {
        const fbToken = fbResponse.authResponse.accessToken;
        window.FB.api(
          "/me",
          {
            fields: "email",
          },
          async (facebookUser) => {
            await dispatch("authorizeFbLogin", {
              facebookUser,
              fbToken,
            });
            cb();
          }
        );
      } else {
        // console.log(
        //   "L'utente ha annullato il login o non ha completato il processo."
        // );
      }
    });
  },
  authorizeFbLogin: async ({ dispatch, commit }, { facebookUser, fbToken }) => {
    const res = await $authorizeFbLogin({ facebookUser, fbToken });
    if (res.id && res.userId) {
      commit("postLogin", res);
      await dispatch("getAuthToken", res.id);
      await dispatch("getUserData", {
        id: res.userId,
        token: res.id
      })
    }
  },
  logout: async ({ commit }) => {
    if (window.FB) await window.FB.logout();
    commit("logout");
  },
  refreshToken: async ({ commit }, payload) => {
    const res = await $refreshToken(payload.loginState.refreshToken);
    commit("setToken", res.accessToken);
    commit("setRefreshToken", res.refreshToken);
  },
  changePassword: async ({ commit }, { payload, token }) => {
    const res = await $changePassword(payload, token);
    commit("changePasswordState", res);
  },
};

const namespaced = true;

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced,
};
